module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray@3x-de5778393fbbb35ead62719d7b0f4cb1.png";